<template>
 <div id="mySendyModal" class="overlay fade-in-overlay">
     <div class="sendyModal">
           <a href="javascript:void(0)" class="closebtn" v-on:click="closeSendyModal();">x</a>
           <div class="content-image"><img src="../assets/images/dwerve_follow.jpeg" alt=""></div>
           <div class="sendyWrap">
                <h2 class="follow-title">Subscribe to our newsletter!</h2>
                <h4  class="follow-subtitle">You will be entered for a chance to win alpha access!</h4>
            </div>
            <form @submit="onSubmit" method="POST" ref="form" id="sendy-form">
                
                <input type="hidden" name="list" value="y3Ep0BGWhxkmrB1763I53pMQ"/>
                <input type="hidden" name="api_key" value="Z0skjz8tyn5VcME6DCmr"/>
                <div id="hp">
                    <label for="hp">HP</label>
                    <input type="text" name="hp" id="hp">
                </div>
            <div class="sendyInlineWrapper">
                    <div class="sendySubmitInline">
                        <input type="email" v-model="email" name="email" placeholder="Enter email address" id="email"/>
                        <input type="image" class="animated pulse animated-infinite bounce_button" src="https://dwerve.com/static/assets/images/Subscribe.png"  name="submit" id="submit"/>
                    </div>
            </div>
            
            </form>
     </div>
 </div>
</template>

<script>

export default {
        data() {
            return {
              email: '',
              description: '',
              output: ''
            };
        },
 methods: {
    onSubmit(e) {
        e.preventDefault();
       function setCookie(cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
          var expires = "expires="+d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
        var self = this;
        $.ajax({
            type: 'POST',
            url: 'https://mail.halfhumangames.com/subscribe',
            api_key: "Z0skjz8tyn5VcME6DCmr",              
            list: "y3Ep0BGWhxkmrB1763I53pMQ",
            data: $('#sendy-form').serialize(),
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
                }, 
            boolean: true,
            success: function (data) {
            if(data.includes("You're already subscribed!"))
                {
                    self.$alert("You're already subscribed!");
                     document.getElementById("mySendyModal").style.display = "none";
                    self.$ga.event('Sign Up', 'Suscribe', 'Suscribe Form', 1);
                }
                else if (data.includes("You're subscribed!"))
                {
                    self.$alert("You've been subscribed!");
                     document.getElementById("mySendyModal").style.display = "none";
                    self.$ga.event('Sign Up', 'Suscribe', 'Suscribe Form', 1);
                }
                else if (data.includes("Thank you, a confirmation email has been sent to you."))
                {
                    self.$alert("A confirmation email has been sent. If you do not see it in your inbox, please check the spam folder.","Thanks for suscribing!",'success');
                
                    self.$ga.event('Sign Up', 'Suscribe', 'Suscribe Form', 1);
                     document.getElementById("mySendyModal").style.display = "none";
                    setCookie("noPopup", "noPopup", 30);
                    
                }
                else if (data.includes("A confirmation email had already been sent to you."))
                {
                    self.onNotConfrimed(e);
                     document.getElementById("mySendyModal").style.display = "none";
                    self.$ga.event('Sign Up', 'Suscribe', 'Suscribe Form', 1);
                    
                
                }
                else {
                    console.log(data);
                    
                    
            }
            }
        
        });
      
    },
    closeSendyModal() {
        document.getElementById("mySendyModal").style.display = "none";
    },
    onNotConfrimed(e){
          e.preventDefault();
       
       var self = this;
       $.ajax({
        type: 'POST',
        url: 'https://mail.halfhumangames.com/unsubscribe',
        api_key: "Z0skjz8tyn5VcME6DCmr",              
        list: "y3Ep0BGWhxkmrB1763I53pMQ",
        data: $('#sendy-form').serialize(),
        headers: {
            'Content-type': 'application/x-www-form-urlencoded'
            }, 
        boolean: true,
        success: function (data) {
               self.onReSubmit(e);
            
                 
        }
        
    });
    },
     onReSubmit(e){
       e.preventDefault();
       
       var self = this;
       $.ajax({
        type: 'POST',
        url: 'https://mail.halfhumangames.com/subscribe',
        api_key: "Z0skjz8tyn5VcME6DCmr",              
        list: "y3Ep0BGWhxkmrB1763I53pMQ",
        data: $('#sendy-form').serialize(),
        headers: {
            'Content-type': 'application/x-www-form-urlencoded'
            }, 
        boolean: true,
        success: function (data) {
                   self.$alert("A confirmation email has been sent. If you do not see it in your inbox, please check the spam folder.","Thanks for suscribing!",'success');
        }
        
    });
    },

 },
 mounted(){

 }

};
</script>

<style scoped>
div#mySendyModal {
    display: none;
  z-index: 40;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    background-color: hsla(0,0%,4%,.86);
}
.sendyModal {
    margin: auto;
    position: relative;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    width: 45em;
    max-width: 440px;
    padding: 0;
    z-index: 9999;
    border: none;
    border-radius: .3125em;
    background: #fff;
    font-family: inherit;
    display: flex;
    font-size: 1rem;
}
a.closebtn {
    width: 30px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    text-transform: lowercase;
    height: 30px;
    background-color: #fff;
    border-radius: 100%;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.2);
    cursor: pointer;
    position: absolute;
    right: -10px;
    top: -10px;
    font-size: 17px;
    z-index: 9999;
    text-shadow: none;
    color: #000;
}
.sendyModal input#email {
    width: 100%;
    height: 40px;
    position: relative;
    top: 6px;
    font-size: 12px;
    padding: 10px;
    color: #a2a2a2;
}
.sendySubmit{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.sendySubmit input#submit {
    width: 127px;
}

p.g-recaptcha iframe {
    width: 100%;
    margin-top: 10px;
}
p.g-recaptcha div {
    width: 100% !important;
    height: auto !important;
}

p.g-recaptcha {
    margin-bottom: 0;
    width: 100%;
    margin-top: 10px;
}
.sendyWrap form {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.sendyModal label {
    width: 100%;
    font-family: Grandmaster;
    font-size: 13px;
    color: #595959;
    text-shadow: none;
    text-align: left;
    text-transform: none;
    font-weight: 100;
    margin-bottom: 0px;
    position: absolute;
}
#hp{
    display: none;
}
.sendySubmit {
    margin-top: 29px;
}
.sendySubmitInline input#email{
    max-width: 441px;
    margin-right: 10px;
    color: #555;
    width: 100%;
    font-weight: 400;
    font-size: 15px;
    padding: 10px;
    border-radius: 3px;
    color: #bfb6b6;
    height: 44px;
   background-color: rgba(0, 0, 0, 0.11);
    border: 1px solid hsla(0,0%,100%,.39);
}
.sendySubmitInline {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    max-width: 700px;
    margin: auto;
}
p.subtitle span {
    font-size: 20px;
    text-shadow: -2.4px 2.6px 0 #282e35, 0.6px -2.4px 0 #282e35;
    display: inline-block;
}

.sendySubmitInline input#submit {
   width: 119px;
    height: auto;
    margin-top: 17px;
}
p.subtitle {
   font-size: 16px !important;
    margin-bottom: 0;
    color: #fff !important;
    font-family: Grandmaster;
    padding-top: 5px;
    padding-left: 23px;
        width: 100%;
    line-height: 1.5;
    text-align: center;
    text-shadow: -2.4px -2.4px 0 #282e35, -2.4px -1.4px 0 #282e35, -2.4px -0.4px 0 #282e35, -2.4px 0.6px 0 #282e35, -2.4px 1.6px 0 #1d1a44, -2.4px 2.6px 0 #282e35, -1.4px -2.4px 0 #282e35, -1.4px -1.4px 0 #282e35, -1.4px -0.4px 0 #282e35, -1.4px 0.6px 0 #282e35, -1.4px 1.6px 0 #282e35, -1.4px 2.6px 0 #282e35, -0.4px -2.4px 0 #282e35, -0.4px -1.4px 0 #282e35, -0.4px -0.4px 0 #282e35, -0.4px 0.6px 0 #282e35, -0.4px 1.6px 0 #282e35, -0.4px 2.6px 0 #282e35, 0.6px -2.4px 0 #282e35, 0.6px -1.4px 0 #282e35, 0.6px -0.4px 0 #282e35, 0.6px 0.6px 0 #282e35, 0.6px 1.6px 0 #282e35, 0.6px 2.6px 0 #282e35, 1.6px -2.4px 0 #282e35, 1.6px -1.4px 0 #282e35, 1.6px -0.4px 0 #282e35, 1.6px 0.6px 0 #282e35, 1.6px 1.6px 0 #282e35, 1.6px 2.6px 0 #282e35, 2.6px -2.4px 0 #282e35, 2.6px -1.4px 0 #282e35, 2.6px -0.4px 0 #282e35, 2.6px 0.6px 0 #282e35, 2.6px 1.6px 0 #282e35, 2.6px 2.6px 0 #282e35;
}
.sign__word {
  font-size: 5.6rem;
  text-align: center;
  line-height: 1;
  color: #3c9bd0;
  
  
}

@keyframes flash{
    0%{
        color: #b0e1fc;
        }
    25%{
        color: #66f0e9;
    }
    50%{
        color: #33ebe1;
        }
    75%{
        color: #7ee7a1;
        }
    100%{
        color: #74d4e6;
        }
}

@media only screen and (max-width: 500px) {
    .sendyInlineWrapper {
        position: relative;
        top: 20px;
    }
    .sendySubmitInline input#email {
        margin-bottom: 10px;
        margin-right: 0;
        max-width: 320px;
        
    }
    p.subtitle{
        padding-left: 0;
        padding-top: 15px;
        line-height: 1.8;
    }
    .sendySubmitInline{
        margin-bottom: 10px;
    }
}
.animated.delay-3s {
  -webkit-animation-delay: 3s;
  animation-delay: 3s;
}
form#sendy-form {
   padding: 5px 20px 20px 20px;
}
.sendyWrap {
    padding: 5px 20px 0px;
}
h2.follow-title {
    text-shadow: 1px 1px 1px rgba(0, 41, 76, 0.12);
    font-weight: 900;
    font-size: 23px;
    font-family: Roboto, Arial, sans-serif;
    color: #555;
}
</style>